// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { StaticPageModule } from './app.module';
bootstrapAppModule(StaticPageModule);
